import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';
import { PureFunctionPipe } from '@coin/shared/core/util-pipes';

@Component({
  selector: 'coin-siemens-energy-faq-answer-level',
  templateUrl: './faq-answer-level.component.html',
  styleUrls: ['./faq-answer-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, V2ButtonComponent, PureFunctionPipe]
})
export class FaqAnswerLevelComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() items: any;

  public openPage(link: string): void {
    window.open(link, '_blank');
  }

  public cutOutNbsp(text: string): string {
    return text?.replaceAll(/&nbsp;(?!<)|(?<!>)&nbsp;/g, ' ');
  }
}
